import { useEffect, useState } from 'react';

import { useAppState } from '@/overmind';

import { HighlightedGridElements } from '../../../overmind/calculation/HighlightedGridElements';
import type { HighlightStates } from '../utils/styleMapElement';

export function useHighlightedFeatures(): [HighlightStates] {
  const gridElementsDetails = useAppState().calculation.gridElementDetails;
  const [statuses, setStatuses] = useState<HighlightStates>({
    type: 'NONE_HIGHLIGHTED'
  });

  useEffect(() => {
    if (
      gridElementsDetails.type === 'EVALUATED' &&
      gridElementsDetails.elements.length > 0
    ) {
      const highlightedGridElements = HighlightedGridElements.from(
        gridElementsDetails.elements
      ).toRecord();
      setStatuses({
        type: 'SOME_HIGHLIGHTED',
        context: { highlighted: highlightedGridElements }
      });
    }
  }, [gridElementsDetails]);

  if (gridElementsDetails.type === 'NO_EVALUATION')
    return [
      {
        type: 'NONE_HIGHLIGHTED'
      }
    ];

  return [statuses];
}
